import { render, staticRenderFns } from "./PreviewFormsRFLM.vue?vue&type=template&id=afb7c5a8"
import script from "./PreviewFormsRFLM.vue?vue&type=script&lang=ts"
export * from "./PreviewFormsRFLM.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports